import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const mapStateToProps = state => ({
	token: state.cms.authentication.token,
});

function withAuthGuard(WrappedComponent) {
	class withAuthGuardComponent extends Component {
		constructor(props) {
			super(props);

			if (!props.token) {
				props.history.push('/cms/login');
			}
		}
		state = {};
		render() {
			const { token, children, ...rest } = this.props;
			return <WrappedComponent {...rest}>{children}</WrappedComponent>;
		}
	}

	return connect(mapStateToProps)(withRouter(withAuthGuardComponent));
}

export default withAuthGuard;



// WEBPACK FOOTER //
// ./src/helpers/withAuthGuard.js